import { appendPath } from '@truqc/content-path';
import contentPathSelector from './contentPathSelector';
export default (state, props) => {
  const contentPath = contentPathSelector(state, props);
  const _props$parentContentP = props.parentContentPath,
    parentContentPath = _props$parentContentP === void 0 ? '/' : _props$parentContentP;
  if (contentPath) {
    return appendPath(parentContentPath, contentPath);
  }
  return parentContentPath;
};